import { useState, useEffect, useRef, useMemo } from "react";
import useMediaQueryHook from "@hooks/useMediaQueryHook";
import MealSection from "./MealSection";
import ButtonLoader from "@components/ui/Loaders/ButtonLoader";
import AlertDialog from "@components/ui/ConfirmDialogue";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BannerImage from "@assets/images/selectionBanner.png";
import dayjs from "dayjs";
import SnacksDetails from "@features/diet/WeeklyMealPlaner/SnacksDetails";
import { ReactComponent as Disclaimer } from "@assets/images/disclaimer.svg";
import NotFound from "@components/ui/NotFound";
import { initialSelectMealList } from "data/dietPlanConst.js/index.js";
import { ReactComponent as LunchTime } from "@assets/images/LunchTime.svg";
import { ReactComponent as SnackTime } from "@assets/images/image 259.svg";
import leftImage from "@assets/images/LeftImage.png";
import { useSelector } from "react-redux";
import { NavigationPrompt } from "@utils/NavigationBlocker.js";
import ActualDietPlanLoader from "@components/ui/Loaders/ActualDietPlanLoader.jsx";
import { useTranslation } from "react-i18next";
import { getPlan, rejectDietPlan, saveSelectedDietPlan } from "api/dietPlan.js";
const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

const WeeklyMealSelection = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const mealsToShow = useSelector((state) => state.selectedMeals.mealToShow);
  const [firstLoad, setFirstLoad] = useState(true);
  // const imageIntervalRef = useRef(null);
  // const [imagesLoaded, setImagesLoaded] = useState(false);
  const [formSubmitting, setFormSubmitting] = useState(true);
  const [tab, setTab] = useState("Meals");
  const [mealList, setMealList] = useState(null);
  const { isMobile } = useMediaQueryHook();
  const [selectedDay, setSelectedDay] = useState(() => dayjs().format("dddd"));
  const [dietPlanLoading, setDietPlanLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [sortedAvailableDays, setSortedAvailableDays] = useState(null);
  const mealTypes = ["Breakfast", "Lunch", "Dinner"];
  const [selectedMeals, setSelectedMeals] = useState(
    initialSelectMealList.selectedMeals,
  );
  const [cancelAllowed, setCancelAllowed] = useState(false);
  const [discardOpen, setDiscardOpen] = useState(false);
  const [discardLoading, setDiscardLoading] = useState(false);
  const [loadingMeals, setLoadingMeals] = useState({});
  const [globalLoading, setGlobalLoading] = useState(false);
  const { planStartDate, setPlanStartDate } = useState(null);
  const startDate = new Date();
  const daysToSort = Array.from({ length: 7 }, (_, i) => {
    const currentDate = new Date(startDate);
    currentDate.setDate(startDate.getDate() + i);
    return {
      day: currentDate.toLocaleDateString("en-US", { weekday: "long" }),
    };
  });
  const [countdown, setCountdown] = useState(0);
  const countdownRef = useRef(null);
  const timeoutRef = useRef(null);
  const isMountedRef = useRef(true);

  const startCountdown = (time, incrementSeconds = false) => {
    setCountdown(time);
    countdownRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 0) {
          clearInterval(countdownRef.current);
          return 0;
        }

        if (prev === 2 && incrementSeconds) {
          return prev + 10 - 1; // +10 then -1 for this tick
        }

        return prev - 1;
      });
    }, 1000);
  };

  const extractAllImages = (dayImages) => {
    const snacks = dayImages?.Snacks || {};

    const result = {
      Breakfast: dayImages?.Meals?.Breakfast || [],
      Lunch: dayImages?.Meals?.Lunch || [],
      Dinner: dayImages?.Meals?.Dinner || [],
      afternoon_snacks: snacks["Afternoon Snacks"] || null,
      evening_snacks: snacks["Evening Snacks"] || null,
    };

    return result;
  };

  const orderDaysGet = (CommingDate) => {
    return Array.from({ length: 7 }, (_, i) => {
      const currentDate = new Date(CommingDate);
      currentDate.setDate(currentDate.getDate() + i);
      return {
        day: currentDate.toLocaleDateString("en-US", { weekday: "long" }),
      };
    });
  };

  const handleSetDietPlan = (data) => {
    if (data?.diet_plan) {
      // const diet_plan = data?.diet_plan;
      // const dayOrder = daysToSort.map((item) => item.day);

      // const dietPlan = Object.fromEntries(
      //   Object.entries(diet_plan).sort((a, b) => {
      //     const indexA = dayOrder.indexOf(a[0]);
      //     const indexB = dayOrder.indexOf(b[0]);
      //     return indexA - indexB;
      //   })
      // );
      const diet_plan = data?.diet_plan;

      const planStartDate = data?.plan_start_date;
      // const dayOrder = daysToSort.map((item) => item.day);
      const dayOrder = orderDaysGet(startDate);

      const dayOrderStrings = dayOrder.map((item) => item.day);

      const dietPlan = Object.fromEntries(
        Object.entries(diet_plan).sort((a, b) => {
          const indexA = dayOrderStrings.indexOf(a[0]);
          const indexB = dayOrderStrings.indexOf(b[0]);
          return indexA - indexB;
        }),
      );
      const images = data?.images || [];
      const updatedMealList = Object.keys(dietPlan)?.map((day, index) => {
        // const meals = extractAllMeals(dietPlan[day].Meals);

        const imageSet = extractAllImages(images[day]);
        const date = dietPlan[day].Date;
        const dayData = dietPlan[day];
        const snacks = dayData?.Snacks;
        return {
          day: day,
          date: date,
          meal: dietPlan[day].Meals ?? "No Meal",
          images: imageSet ?? {},
          color: index % 2 === 0 ? "bg-pink-500" : "bg-blue-500",
          snacks: {
            afternoon_snacks: snacks["Afternoon Snacks"]
              ? snacks["Afternoon Snacks"]
              : null,
            evening_snacks: snacks["Evening Snacks"]
              ? snacks["Evening Snacks"]
              : null,
          },
        };
      });

      const sortedMealList = [...updatedMealList].sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setMealList(sortedMealList);

      // if (data.images_loaded) {
      //   setImagesLoaded(true);
      //   if (imageIntervalRef.current) {
      //     clearInterval(imageIntervalRef.current);
      //     imageIntervalRef.current = null;
      //   }
      // }
      if (firstLoad) {
        const AvailableDays = sortedMealList?.map((meal) => meal.day);
        setSortedAvailableDays(AvailableDays);
      }
      const today = new Date();
      // setPlanStartDate(today);
      // setPlanStartDate(data?.plan_start_date);
    }
  };
  const selectedMeal = mealList?.find((meal) => meal.day === selectedDay);

  const filteredData = useMemo(() => {
    if (!selectedMeal || !mealsToShow[selectedDay]) return null;

    return {
      ...selectedMeal,
      meal: {
        Breakfast: (mealsToShow[selectedDay]?.breakfast || [0])
          .map((index) => {
            const meal = selectedMeal?.meal?.Breakfast?.[index];
            return meal ? { ...meal, originalIndex: index } : null;
          })
          .filter(Boolean),
        Lunch: (mealsToShow[selectedDay]?.lunch || [0])
          .map((index) => {
            const meal = selectedMeal?.meal?.Lunch?.[index];
            return meal ? { ...meal, originalIndex: index } : null;
          })
          .filter(Boolean),
        Dinner: (mealsToShow[selectedDay]?.dinner || [0])
          .map((index) => {
            const meal = selectedMeal?.meal?.Dinner?.[index];
            return meal ? { ...meal, originalIndex: index } : null;
          })
          .filter(Boolean),
      },
      images: {
        Breakfast: (mealsToShow[selectedDay]?.breakfast || [0])
          .map((index) => selectedMeal?.images?.Breakfast?.[index])
          .filter(Boolean),
        Lunch: (mealsToShow[selectedDay]?.lunch || [0])
          .map((index) => selectedMeal?.images?.Lunch?.[index])
          .filter(Boolean),
        Dinner: (mealsToShow[selectedDay]?.dinner || [0])
          .map((index) => selectedMeal?.images?.Dinner?.[index])
          .filter(Boolean),
      },
    };
  }, [selectedMeal, mealsToShow, selectedDay]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickDiscardOpen = () => {
    setDiscardOpen(true);
  };
  const handleSelectedGeneratePlan = async () => {
    try {
      setDietPlanLoading(true);
      const data = await saveSelectedDietPlan(selectedMeals);
      if (data.success) {
        toast.info(t("toast.informationSubmit"));
        navigate("/diet-plan", { replace: true });
      }
    } catch (error) {
      console.error("Error saving preferences:", error);
      toast.error(t("toast.failedSubmit"));
    } finally {
      setDietPlanLoading(false);
    }
  };

  const handelCancelPlan = async () => {
    try {
      setDiscardLoading(true);
      await rejectDietPlan();
      toast.info(t("toast.Plan Discarded successfully"));

      setFormSubmitting(false);
      setDiscardOpen(false);

      navigate("/diet-plan", { replace: true });
    } catch (error) {
      console.error("Error discarding meal:", error);
      toast.error(t("toast.Failed to discard plan. Please try again."));
    } finally {
      setDiscardLoading(false);
    }
  };

  const handleClose = (key) => {
    if (key === "cancel") {
      setOpen(false);
    } else {
      handleSelectedGeneratePlan();
      setFormSubmitting(false);
      setOpen(false);
    }
  };

  const handleDiscardClose = (key) => {
    if (key === "cancel") {
      setDiscardOpen(false);
    } else {
      handelCancelPlan();
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    let isMounted = true;

    const fetchData = async () => {
      try {
        const data = await getPlan();
        if (isMounted) {
          setCancelAllowed(data?.cancel_allowed);
          handleSetDietPlan(data);
        }
      } catch (error) {
        console.error("Error fetching diet plan:", error);
      } finally {
        if (isMounted) {
          setFirstLoad(false);
        }
      }
    };

    fetchData();

    return () => {
      isMountedRef.current = false;
      isMounted = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!location.state) {
      navigate(-1);
    }
  }, [location.state, navigate]);
  const renderMealSection = (mealType) => (
    <MealSection
      mealType={mealType}
      selectedMeal={selectedMeal}
      filteredMeal={filteredData}
      setSelectedMeals={setSelectedMeals}
      base_url={BASE_URL}
      handleSetDietPlan={handleSetDietPlan}
      selectedIndex={
        selectedMeals?.[selectedMeal?.day]?.[mealType.toLowerCase()] || 0
      }
      timeoutRef={timeoutRef}
      isMountedRef={isMountedRef}
      countdown={countdown}
      countdownRef={countdownRef}
      startCountdown={startCountdown}
      loadingHide={loadingMeals}
      loading={loadingMeals[selectedMeal.day]?.[mealType]}
      onSetLoading={(isLoading) => {
        setLoadingMeals((prev) => {
          const updatedState = {
            ...prev,
            [selectedMeal.day]: {
              ...(prev[selectedMeal.day] || {}),
              [mealType]: isLoading,
            },
          };
          const isAnyMealLoading = Object.values(updatedState).some(
            (day) => day && Object.values(day).some((loading) => loading),
          );

          setGlobalLoading(isAnyMealLoading);

          return updatedState;
        });
      }}
      globalLoading={globalLoading}
    />
  );
  if (location.state) {
    return (
      <>
        <NavigationPrompt when={formSubmitting} mealSelection={true} />
        {firstLoad ? (
          <ActualDietPlanLoader />
        ) : (
          <div className="bg-white  rounded-[36px]">
            <div
              className="w-full h-[356px] relative block bg-white rounded-[36px]"
              style={{
                backgroundImage: `url(${BannerImage})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <img
                src={leftImage}
                className="absolute top-[-1px] -left-[1px] 2xl:top-[-3px] 2xl:left-[-2px] bg-[transparent] w-[49%] md:w-[38%] lg:w-[30%] xl:w-[26%]"
              />
              <button className="absolute cursor-default w-[35%] lg:w-[23%] xl:w-[19%] left-5 md:left-1 lg:left-3 xl:left-5 top-[5px] md:top-3 lg:top-[6px]  xl:top-[3%] 2xl:top-[6%]  p-[8px] lg:p-[10px] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white rounded-[100px] text-nowrap text-[9px] lg:text-[12px] xl:text-[14px]">
                {t(`weeklyMealSelection.menuDetail`)}
              </button>
            </div>
            <div className="p-[18px] md:px-[36px] md:py-5">
              <div className="flex items-center mb-2 md:m-0 gap-2 bg-[#DDF7FF] text-[#00C7FE] border border-[#00C7FE] border-dashed text-[12px font-[Lato] font-[500] rounded-2xl px-3 py-2">
                <div className="bg-white p-1 rounded-full">
                  <Disclaimer className="w-6 h-6" />
                </div>
                <p>{t("disclaimer")}</p>
              </div>
              {!isMobile ? (
                <div className="hidden md:flex bg-white rounded-full p-1 border border-[#E9E9E9] w-full gap-0 md:gap-2 my-3 shadow-md">
                  {sortedAvailableDays?.map((day) => (
                    <button
                      key={day}
                      className={`text-[14px] font-[400] font-[Lato] px-3 py-[11px] flex-1 border border-[1px] border-[transparent]
                        ${globalLoading && "opacity-60 hover:border-[transparent] hover:text-black bg-gray-200"}
                        ${
                          selectedDay === day
                            ? "text-white bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[100px] hover:!text-white"
                            : "text-black hover:border hover:border-[#0575e6] hover:text-[#0575e6] rounded-[100px]"
                        }`}
                      disabled={globalLoading}
                      onClick={() => setSelectedDay(day)}
                    >
                      {/* {day} */}
                      {t(`days.${day.toLowerCase()}`)}
                    </button>
                  ))}
                </div>
              ) : (
                <div className="flex items-center rounded-[8px] gap-1 w-full border border-[2px] border-[#F2F2F2B8] overflow-x-auto">
                  {sortedAvailableDays?.map((day, index) => {
                    return (
                      <div
                        key={index}
                        className={`flex flex-col flex-1 rounded-md !py-[28px] !px-[5px] cursor-pointer border border-white gap-[10px] ${
                          selectedDay === day &&
                          "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white "
                        }`}
                        onClick={() => setSelectedDay(day)}
                      >
                        <p
                          className={`text-[14px] font-[Lato] ${
                            selectedDay === day && "text-white"
                          }  font-[400] text-center`}
                        >
                          {t(
                            `dietPlanDashboard.allMeals.daysShort.${day?.slice(
                              0,
                              3,
                            )}`,
                          )}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
              <div className="flex justify-center items-center m-2 md:my-[32px] gap-2 md:gap-5 text-[14px] md:text-[16px] font-[Lato]">
                <button
                  className={`px-2 md:px-5 py-1 border border-gray-300  rounded-[8px] flex gap-2 items-center ${
                    tab === "Meals"
                      ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)]  text-white"
                      : " hover:border-[#0575e6] hover:text-[#0575e6]"
                  }`}
                  onClick={() => setTab("Meals")}
                >
                  <LunchTime />
                  {t(`weeklyMealDetails.mealTabName`)}
                </button>
                <button
                  className={`px-2 md:px-5 py-1 border border-gray-300  rounded-[8px] flex gap-2 items-center
                    ${globalLoading && "opacity-60 hover:border-[transparent] hover:text-black bg-gray-200"}
                    ${
                    tab === "Snacks"
                      ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)]  text-white"
                      : " hover:border-[#0575e6] hover:text-[#0575e6]"
                  }`}
                  disabled={globalLoading}
                  onClick={() => setTab("Snacks")}
                >
                  <SnackTime />
                  {t(`weeklyMealDetails.snacksTabName`)}
                </button>
              </div>
              {tab === "Meals" ? (
                selectedMeal ? (
                  <div className="space-y-[12px]">
                    {mealTypes.map((type) => renderMealSection(type))}
                  </div>
                ) : (
                  <NotFound message={`No meal found for ${selectedDay}.`} />
                )
              ) : selectedMeal?.snacks?.afternoon_snacks ||
                selectedMeal?.snacks?.evening_snacks ? (
                <div className="space-y-0">
                  <SnacksDetails
                    mealType="Afternoon Snacks"
                    meal={selectedMeal.snacks.afternoon_snacks}
                    selectedMeal={selectedMeal}
                    mealKey="afternoon_snacks"
                    mealSelection={true}
                  />
                  <SnacksDetails
                    mealType="Evening Snacks"
                    meal={selectedMeal.snacks.evening_snacks}
                    selectedMeal={selectedMeal}
                    mealKey="evening_snacks"
                    mealSelection={true}
                  />
                </div>
              ) : (
                <NotFound message="No Snacks Found" />
              )}
              <div className="flex justify-center gap-4">
                {cancelAllowed && (
                  <button
                    onClick={() => handleClickDiscardOpen()}
                    disabled={
                      discardLoading || dietPlanLoading || globalLoading
                    }
                    className={`mt-4 px-[20px] py-[10px] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white rounded-full min-w-[140px] ${
                      (dietPlanLoading || discardLoading || globalLoading) &&
                      "opacity-70"
                    }`}
                  >
                    {discardLoading ? (
                      <ButtonLoader />
                    ) : (
                      t(`weeklyMealSelection.discardMeal`)
                    )}
                  </button>
                )}
                <button
                  onClick={() => handleClickOpen()}
                  disabled={dietPlanLoading || discardLoading || globalLoading}
                  className={`mt-4 px-[20px] py-[10px] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white rounded-full min-w-[140px] ${
                    (dietPlanLoading || discardLoading || globalLoading) &&
                    "opacity-70"
                  }`}
                >
                  {dietPlanLoading ? (
                    <ButtonLoader />
                  ) : (
                    t(`weeklyMealSelection.saveMeal`)
                  )}
                </button>
              </div>
            </div>

            <AlertDialog
              open={open}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              isLoading={dietPlanLoading}
              heading={t("Confirm Selection")}
              message={t(
                "Are you sure you want to save these meals? Your meal plan will be updated based on this selection.",
              )}
            />

            <AlertDialog
              open={discardOpen}
              handleClickOpen={handleClickDiscardOpen}
              handleClose={handleDiscardClose}
              isLoading={discardLoading}
              heading={t("Discard Selection")}
              message={t("Are you sure you want to discard these meals?")}
            />
          </div>
        )}
      </>
    );
  }
};

export default WeeklyMealSelection;
